import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import * as api from "./AuthApi";
import { InputPadrao, InputPasswordPadrao, LabelPadrao, LoadingContainerPadrao, SemDados } from "../../components/Base";
import Mensagens from "../../components/Mensagens";
import Fundo from "../../assets/login_bg.png";
import User from "../../assets/user_login.svg";
import { Button, Divider, Tooltip } from "antd";
import BtnAtualizarDados from "../../components/BtnAtualizarDados";
import { BtnLink } from "../../components/Buttons";
import LoadingScreen from "../../components/LoadingScreen";
import SpinnerPadrao from "../../components/SpinnerPadrao";

function Login(props) {
    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");
    const [atualizando, setAtualizando] = useState(false);
    const [progressoAtualizacaoCadastro, setProgressoAtualizacaoCadastro] = useState(null);
    const [logar, loading] = useSave(() => api.login(props.fetch, { user, pass }), data => {
        props.logIn(data);
        props.history.push("/");
    }, { onRejected: (error) => { Mensagens.showErro(error); } });
    const [isDark, setIsDark] = useState(false);
    const [intervalo, setIntervalo] = useState(null);

    const inputUserRef = useRef();
    const inputPassRef = useRef();

    useEffect(() => {

        let lastuser = localStorage.getItem("lastuser");

        if (!!lastuser) {
            setUser(lastuser);
            inputPassRef?.current?.focus();
        }
        else
            inputUserRef?.current?.focus();

        let tema = localStorage.getItem("THEME_DARK");
        setIsDark(tema === "true");

        if (!!props.idCadastro) {
            setProgressoAtualizacaoCadastro({});
            props.fetch().post("integracao/atualizar/informarprogresso").catch(res => console.log(res));
            setIntervalo(setInterval(() => props.fetch().post(`auth/progressocadastro/${props.idCadastro}`).then(s => setProgressoAtualizacaoCadastro(s.data)), 5000));
        }

    }, []);

    useEffect(() => {
        if (progressoAtualizacaoCadastro?.concluido) {
            clearInterval(intervalo);
            setProgressoAtualizacaoCadastro(null);
            if (progressoAtualizacaoCadastro.sucesso)
                Mensagens.showSucesso(progressoAtualizacaoCadastro.processoAtual);
            else
                Mensagens.showErro(progressoAtualizacaoCadastro.processoAtual);
        }
        else if (!progressoAtualizacaoCadastro)
            clearInterval(intervalo);

    }, [progressoAtualizacaoCadastro?.concluido]);

    const handleSubmit = event => {
        event.preventDefault();
        if (!atualizando)
            logar();
    };

    if (!!progressoAtualizacaoCadastro)
        return <div style={{ height: "100vh", width: "100%" }}>
            <LoadingScreen msg={<div>
                <LabelPadrao style={{ color: isDark ? "#fff" : "#333", fontSize: "1.2em", }} >Integração inicial em andamento</LabelPadrao>
                <p style={{ color: isDark ? "#fff" : "#333", textAlign: "center", marginTop: 10, fontSize: "1.1em", }} >{progressoAtualizacaoCadastro?.processoAtual || "iniciando"}</p>
                <SpinnerPadrao />
            </div>} noSpinner loading />
        </div>;
    else
        return <div style={{ height: "100vh", background: `url(${Fundo}) no-repeat`, backgroundSize: "cover", backgroundColor: isDark ? "#494949" : "#fff", display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
            <Tooltip placement="bottom" title="Atualizar dados" >
                <div style={{ position: "absolute", top: 25, border: "1px solid gray", borderRadius: 10, padding: 10 }}>
                    <BtnAtualizarDados style={{ color: isDark ? "#fff" : "#333" }} setLoading={l => setAtualizando(l)} />
                </div>
            </Tooltip>
            <form onSubmit={handleSubmit}>
                <div style={{ width: 430, borderRadius: 4, padding: 10, marginTop: -100 }}>
                    <div style={{ display: "flex", justifyContent: "center", userSelect: "none", pointerEvents: "none" }}>
                        <img src={User} style={{ width: 140, marginBottom: 25 }} />
                    </div>
                    <div>
                        <InputPadrao data-cy="input-user" placeholder="Usuário" value={user} onChange={e => setUser(e.target.value)} ref={inputUserRef} />
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <InputPasswordPadrao placeholder="Senha" value={pass} onChange={e => setPass(e.target.value)} ref={inputPassRef} />
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <Button data-cy="btn-login" type="primary" style={{ width: "100%", background: "#fff", color: "#333", fontWeight: "bold", borderColor: "#ddd", borderRadius: 20 }} htmlType="submit" loading={loading} disabled={atualizando}>{loading ? 'Entrando...' : 'Entrar'}</Button>
                    </div>
                </div>
            </form>

            <LoginUsuario isDark={isDark} {...props} />
        </div>;
}

function LoginUsuario({ isDark, ...props }) {
    const [usuarios, listar, listando] = useFetch(() => props.fetch().get("/auth/usudev"), null, { onRejected: () => { } });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!!props.ambiente && props.ambiente != "Prod" && props.isCadastrado)
            listar();
    }, [props.isCadastrado, props.ambiente]);

    const loginDev = id => {
        if (loading)
            return;

        setLoading(true);
        props.fetch().post(`/auth/loginbyid/${id}`).then(res => {
            const data = res.data;

            if (data.success == false) {
                Mensagens.showErro(data.message);
                setLoading(false);
            }
            else props.logIn(data);

        }).catch(err => {
            const data = err.response.data;
            Mensagens.showErro((err.response.status === 400 && !!data) ? data : "Erro ao efetuar login.");
            setLoading(false);
        });
    };

    return <div style={{ position: "absolute", top: 0, right: 0, padding: 10 }} >
        {usuarios && <LoadingContainerPadrao loading={loading} >
            <div style={{ width: 400, padding: 10, borderRadius: 10, marginBottom: 20, overflow: "auto", background: isDark ? "#252525" : "#fff" }} className="box-shadow-padrao">
                <h2 style={{ textAlign: "center", color: isDark ? "#fff" : "#333" }}>Usuários</h2>
                <Divider style={{ margin: 0, borderColor: isDark ? "#fff" : "#ddd" }} />
                {listando ? <p style={{ textAlign: "center", color: isDark ? "#fff" : "#333" }}>Carregando...</p> : <>
                    {!!usuarios?.length ?
                        usuarios?.map(x => <BtnLink onClick={() => loginDev(x.id)} key={x.id} style={{ display: "block", margin: 0, padding: 0 }}>{x.nome}</BtnLink>) :
                        <SemDados />}
                </>}
            </div>
        </LoadingContainerPadrao>}
    </div>;
}

const mapStateToProps = props => ({ ambiente: props.auth.ambiente, isCadastrado: props.auth.isCadastrado, idCadastro: props.auth.idCadastro });

export default connect(mapStateToProps, { logIn, fetch })(Login);
